export default __webpack_public_path__ + "static/media/manual-shoot.9befef9e.png";